var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      staticStyle: {
        width: "130%",
        "text-align": "center",
        "margin-left": "-10%"
      },
      attrs: { bordered: false }
    },
    [_vm._v("\n  123\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }